export namespace EwalletMomoForm {
  export interface EwalletMomoData {
    policyOwner: string
    IDNumber: string
    phoneNumber: string
    amount: string
  }
}
